<div class="notifications" :class="{ 'changelog-feed--history': history }">
  <PublicPagination v-if="history && visibleEntries.length"
    class="mb-4"
    :page="page" :total-pages="totalPages" :show-page-size="true"
    v-model:page-size="pageSize"
    @first="page = 1" @prev="page = Math.max(1, page - 1)"
    @next="page = Math.min(totalPages, page + 1)" @last="page = totalPages"
  />
  <div v-if="visibleEntries.length" class="notifications__entries">
      <section
        v-for="entry in displayedEntries"
        :key="entry.key"
        class="notifications__entry"
        :class="{
          'notifications__entry--unread': entry.hasUnread,
          'notifications__entry--collapsed': entry.isCollapsed,
        }"
        :data-notification-entry-key="entry.key"
      >
        <div class="notifications__entry-head">
          <div class="notifications__entry-title">
            <component :is="history ? 'h2' : 'span'">{{ entry.title }}</component>
            <small v-if="entry.version || entry.date">
              {{ entry.versionLabel }}<span v-if="entry.versionLabel && entry.date"> · </span>{{ entry.date }}
              </small>
            </div>
          <button
            v-if="entry.canCollapse"
            type="button"
            class="notifications__expand"
            :aria-label="isExpanded(entry.key) ? $t('notifications.collapse') : $t('notifications.expand')"
            :aria-expanded="isExpanded(entry.key)"
            @click="toggleEntry(entry.key)"
          >
            <i :class="isExpanded(entry.key) ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
          </button>
          </div>

        <div
          v-if="history || isExpanded(entry.key)"
          class="notifications__items"
        >
          <article
            v-for="item in entry.displayItems"
            :key="item.key"
            class="notifications__item"
            :class="{ 'notifications__item--unread': item.unread, 'notifications__item--full-entry': item.fullEntry }"
          >
            <component v-if="item.text" :is="history ? 'h3' : 'h6'">{{ item.text }}</component>
            <p v-if="(isExpanded(entry.key) || (history && !item.hasFullText)) && item.descriptionTokens?.length">
              <template v-for="(token, tokenIndex) in item.descriptionTokens" :key="`${item.key}-token-${tokenIndex}`">
                <strong v-if="token.type === 'strong'">{{ token.text }}</strong>
                <em v-else-if="token.type === 'em'">{{ token.text }}</em>
                <code v-else-if="token.type === 'code'">{{ token.text }}</code>
                <a
                  v-else-if="token.type === 'link'"
                  :href="token.href"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ token.text }}</a>
                <span v-else-if="token.type === 'color'" :class="`notifications__text-${token.color}`">
                  {{ token.text }}
                </span>
                <i
                  v-else-if="token.type === 'icon'"
                  class="notifications__icon"
                  :class="token.iconClass"
                  :style="token.iconStyle"
                  aria-hidden="true"
                ></i>
                <br v-else-if="token.type === 'br'" />
                <span v-else>{{ token.text }}</span>
              </template>
            </p>
          </article>
          <router-link
            v-if="!history && entry.hasFullText"
            :to="{ name: 'Changelog', query: { release: entry.key } }"
            class="app-link-button align-self-end"
            @click="$emit('open-history')"
          >{{ $t('notifications.readFull') }}</router-link>
        </div>
      </section>
    </div>

    <div v-else-if="showEmpty" class="notifications__empty small">
      {{ $t('notifications.empty') }}
    </div>
  <PublicPagination v-if="history && visibleEntries.length"
    :page="page" :total-pages="totalPages" :show-page-size="true"
    v-model:page-size="pageSize"
    @first="page = 1" @prev="page = Math.max(1, page - 1)"
    @next="page = Math.min(totalPages, page + 1)" @last="page = totalPages"
  />
</div>
